import { Component, OnInit, inject } from '@angular/core';

import { LoginService2, NavigationService, SharedFeaturesApiService } from '@frontend/vanilla/core';

@Component({
    standalone: true,
    selector: 'lh-pending-post-login-workflow',
    template: '',
})
export class PendingPostLoginWorkflowComponent implements OnInit {
    private api = inject(SharedFeaturesApiService);
    private navigation = inject(NavigationService);
    private loginService = inject(LoginService2);

    ngOnInit() {
        this.api.get('pendingworkflow/postloginredirecturl', {}, { showSpinner: false }).subscribe({
            next: (data: any) => this.navigation.goTo(data.redirectUrl),
            error: async () => await this.loginService.goTo(),
        });
    }
}
